import type { ChangelogEntry } from "../types";

/** Alle ansatte kan endre kundeinfo, ikke bare admin og prosjektledere. */
export const ALLE_KAN_ENDRE_KUNDE_2026_10: ChangelogEntry = {
  id: "2026-10-26-alle-kan-endre-kunde",
  date: "2026-10-26",
  title: "Alle ansatte kan endre kundeinfo",
  summary: "Kundeinfo på kundekortet, som e-post, telefon og adresse, kan nå endres av alle ansatte, ikke bare administratorer og prosjektledere.",
  sections: [
    {
      heading: "Kunder",
      minRole: "user",
      items: [
        {
          title: "Endre kundeinfo uten å være prosjektleder",
          kind: "forbedret",
          body: "Før fikk du «Du må være prosjektleder, kunderådgiver eller admin for å endre kundeinfo» hvis du ikke var prosjektleder eller rådgiver på noe prosjekt. Nå kan alle ansatte endre kundeinfo og overstyre status, på samme måte som de kan opprette kunder. Endringer i felt som finnes i PowerOffice lagres fortsatt der først. Å slette kunder krever det samme som før.",
        },
      ],
    },
  ],
};
